import type React from 'react'
import type { JSX } from 'react'
import type { IOverlayLayoutProps } from 'atoms/OverlayLayout'
import type {
  BANNER_BACK_BUTTON_INDENT,
  LAYOUT_BLOCK_PADDINGS,
} from 'vars/index'
import type {
  LayoutBlockAlignItems,
  LayoutBlockDirection,
  LayoutBlockJustifyContent,
} from './LayoutBlock.h'

import { OverlayLayout } from 'atoms/OverlayLayout'
import {
  LayoutBlockContentSC,
  LayoutBlockImageSC,
  LayoutBlockPictureSC,
  LayoutBlockSC,
} from './LayoutBlock.styled'

export interface ILayoutBlockProps {
  children?: React.ReactNode
  width?: string
  height?: string
  imageUrl?: string
  imageHeight?: string
  isImageFixed?: boolean
  direction?: LayoutBlockDirection
  justifyContent?: LayoutBlockJustifyContent
  alignItems?: LayoutBlockAlignItems
  overlayEnabled?: IOverlayLayoutProps['overlayEnabled']
  overlayWidth?: IOverlayLayoutProps['overlayWidth']
  overlayHeight?: IOverlayLayoutProps['overlayHeight']
  overlayHorizontal?: IOverlayLayoutProps['overlayHorizontalColor']
  overlayVertical?: IOverlayLayoutProps['overlayVerticalColor']
  paddings?: LAYOUT_BLOCK_PADDINGS
  backButtonIndent?: BANNER_BACK_BUTTON_INDENT
  className?: string // https://github.com/callstack/linaria/blob/master/docs/BASICS.md#overriding-styles
  style?: React.CSSProperties
}

export const LayoutBlock = ({
  children,
  width,
  height,
  imageUrl = '',
  imageHeight,
  isImageFixed = true,
  direction,
  justifyContent,
  alignItems,
  overlayEnabled,
  overlayHorizontal,
  overlayVertical,
  overlayHeight,
  overlayWidth,
  paddings,
  backButtonIndent,
  className = '',
  style,
}: ILayoutBlockProps): JSX.Element => (
  <LayoutBlockSC
    blockWidth={width}
    blockHeight={height}
    className={className}
    style={style}
  >
    {imageUrl ? (
      <LayoutBlockPictureSC
        imageHeight={imageHeight}
        isImageFixed={isImageFixed}
      >
        <LayoutBlockImageSC src={imageUrl} alt='' />
        <OverlayLayout
          overlayEnabled={overlayEnabled}
          overlayWidth={overlayWidth}
          overlayHeight={overlayHeight}
          overlayHorizontalColor={overlayHorizontal}
          overlayVerticalColor={overlayVertical}
        />
      </LayoutBlockPictureSC>
    ) : null}
    <LayoutBlockContentSC
      direction={direction}
      justifyContent={justifyContent}
      alignItems={alignItems}
      paddings={paddings}
      backButtonIndent={backButtonIndent}
    >
      {children}
    </LayoutBlockContentSC>
  </LayoutBlockSC>
)

LayoutBlock.displayName = 'LayoutBlock'
